import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import React from 'react'

interface Option {
  id: string
  label: string
}

interface SingleSelectDropdownObjectProps {
  label: string
  options: Option[]
  defaultValue?: string // Change to accept string
  styles?: any
  onChange: (value: Option | null) => void
  fullWidth?: boolean
  disabled?: boolean
  error?: boolean
}

export const SingleSelectDropdownObject: React.FC<
  SingleSelectDropdownObjectProps
> = ({
  label,
  options,
  defaultValue = '',
  styles = {},
  onChange,
  fullWidth,
  disabled = false,
  error = false,
}) => {
  const onValueChange = (event: any) => {
    const selectedId = event.target.value
    const selectedOption =
      options.find((option) => option.id === selectedId) || null
    onChange(selectedOption)
  }

  return (
    <FormControl
      sx={{ minWidth: 180, ...styles }}
      size='small'
      fullWidth={fullWidth}
      disabled={disabled}
    >
      <InputLabel id={`${label}-label`} error={error}>
        {label}
      </InputLabel>
      <Select
        labelId={`${label}-label`}
        id={`${label}-select`}
        value={defaultValue}
        label={label}
        onChange={onValueChange}
        error={error}
      >
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
